<template>
  <div class="audio-control" v-if="canShowAudioControl">
    <audio
      :src="slideActive.audioLink.url"
      controls
      preload="auto"
      :autoplay="isAutoPlay"
      :loop="isRepeat"
      ref="audio-slide-tag"
    />
    <div @click="playAudio()" class="custom-mt-2 custom-mb-2 play-audio" v-if="showAutoPlayWarning">
      <i class="fas fa-play animate__animated animate__flash" /> {{ $t('playAudioNow') }}
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import * as Sentry from '@sentry/vue'

export default {
  components: {
  },
  data() {
    return {
      showAutoPlayWarning: false,
    }
  },
  computed: {
    ...mapGetters({
      slideActive: 'activeActivity',
    }),
    canShowAudioControl() {
      return this.slideActive && this.slideActive.audioPlayOnAudience && this.slideActive.audioLink
    },
    isAutoPlay() {
      return this.slideActive.audioAudienceAutoPlay || this.slideActive.audioAutoPlay
    },
    isRepeat() {
      return this.slideActive.audioAudienceRepeat || this.slideActive.audioRepeat
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    'slideActive.audioAudienceAutoPlay': function (audioAutoPlay) {
      if (this.slideActive.audioPlayOnAudience && audioAutoPlay) {
        this.$refs['audio-slide-tag'].play()
      }
    },
  },
  mounted() {
    if ((this.slideActive.audioAudienceAutoPlay || this.slideActive.audioAutoPlay)
      && this.slideActive.audioPlayOnAudience) {
      const audioSlideTag = this.$refs['audio-slide-tag']
      if (audioSlideTag) {
        const promise = audioSlideTag.play()
        if (promise !== undefined) {
          promise.then(() => {
            this.showAutoPlayWarning = false
            return null
            // Autoplay started!
          }).catch((error) => {
            Sentry.captureException(error)
            // Show something in the UI that the video is muted
            this.slideActive.audioAudienceShowControl = true
            this.showAutoPlayWarning = true
          })
        }
      }
    }
  },
  methods: {
    playAudio() {
      this.$refs['audio-slide-tag'].play()
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.play-audio {
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
}
audio {
  height: 40px;
}
</style>
